<template>
  <div>
    <megabit-base-dialog :show-dialog="show" :width="700">
      <template v-slot:body>
        <v-sheet v-if="isLoading" class="pa-3" dark>
          <v-skeleton-loader
            class="mx-auto"
            :max-width="1024"
            max-height="768"
            type="card"
          ></v-skeleton-loader>
        </v-sheet>
        <v-card v-else dark>
          <v-card-title>
            <span class="text-subtitle-2 font-weight-bold"
              >Cadastro Rápido de Empresas</span
            >
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="cmpValidForm">
              <v-row dense>
                <v-col cols="3">
                  <c-input-documento
                    v-model="form.cgc"
                    class="text-caption"
                    placeholder="Documento"
                    label="Documento"
                    :isBrasil="!isParaguai"
                    :isRequired="true"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    dark
                    dense
                    outlined
                    class="text-caption"
                    placeholder="Nome do cliente"
                    label="Nome"
                    v-model="form.nome"
                    :rules="formRules.textRequired"
                  />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <c-select
                    item-text="TIPO"
                    item-value="TIPO"
                    rotulo="Classificação"
                    :lista="companyTypeList"
                    :item.sync="form.tipoEmpresa"
                  />
                </v-col>
                <v-col>
                  <c-select
                    :lista="countryList"
                    :item.sync="form.pais"
                    itemText="DESCRICAO"
                    itemValue="CODIGO"
                    rotulo="Pais"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <form-buttons @goBack="show = false" @submitForm="register()" />
        </v-card>
      </template>
    </megabit-base-dialog>
  </div>
</template>

<script>
import { validaCpfCnpj, validaRUC } from '@/utils/utils'

import MegabitBaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cSelect from '@/components/shared/base-input/BaseSelect'
import cInputDocumento from '@/components/shared/base-input/BaseInputCpfCnpj'
import FormButtons from '@/components/shared/base-buttons/FormButtons'

import { mapActions, mapGetters } from 'vuex'
export default {
  components: { MegabitBaseDialog, cSelect, cInputDocumento, FormButtons },
  data: () => {
    return {
      isLoading: true,
      formRules: {
        textRequired: [(v) => !!v || 'Este campo é obrigatório.'],
        selectRequired: [(v) => !!v || 'Obrigatório selecionar.'],
      },
    }
  },
  props: {
    form: {
      type: Object,
      default: () => ({
        nome: '',
        cgc: '',
        tipoEmpresa: '',
        pais: '',
      }),
    },
    formValid: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close', value)
        }
      },
    },
    cmpValidForm: {
      get() {
        return this.formValid
      },
      set(value) {
        this.$emit('update:formValid', value)
      },
    },
    // Company Type Module
    ...mapGetters({
      companyTypeList: 'companyTypeModule/getCompanyTypeList',
    }),
    // Country Module
    ...mapGetters({
      countryList: 'countryModule/getCountryList',
    }),

    isParaguai() {
      return this.form.pais
        ? this.form.pais.DESCRICAO == 'PARAGUAY' ||
            this.form.pais.DESCRICAO == 'PARAGUAI'
        : false
    },

    isDocumentoValido() {
      let documento = this.form.cgc
      if (documento) {
        if (this.isParaguai) {
          return validaRUC(documento)
        } else {
          return validaCpfCnpj(documento)
        }
      } else return true
    },
  },
  methods: {
    // Company Type Module
    ...mapActions({
      requestCompanyTypeAPI: 'companyTypeModule/getCompanyTypes',
      // Company Module
      registerCompany: 'companyModule/insertCompany',
      getCompany: 'companyModule/getCompany',
      // Country Module
      requestCountriesAPI: 'countryModule/getCountries',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setMessage: 'dialogModule/setLoadingDialogMessage'
    }),
    goBack() {
      this.$router.back()
    },

    async register() {
      this.$refs.form.validate()
      if (!this.isDocumentoValido) {
        this.$toasted.error('Documento informado não é válido')
        return
      }

      if (this.formValid) {
        try {
          this.showLoadingDialog(true);
          this.setMessage('Cadastrando empresa no sistema');
          const response = await this.registerCompany(this.form)
          this.$toasted.success(response)

          // o código do cadastro sempre volta na mensagem
          const codigo = response.replace(/[^0-9]+/g, '').trim()
          // emitir o código para o form pai
          this.$emit('changeCompany', codigo)
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        }finally{
          this.showLoadingDialog(false);
        }
      }
    },
    async setData() {
      try {
        await this.fetch()

        // setar por padrao
        const type = this.companyTypeList.filter(
          (element) => element.TIPO == 'Balcao'
        )
        this.form.tipoEmpresa = type[0] ?? null

        const country = this.countryList.filter(
          (element) => element.DESCRICAO == 'BRASIL'
        )
        this.form.pais = country[0] ?? null
        this.isLoading = !this.isLoading
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    async fetch() {
      try {
        if (this.companyTypeList.length <= 0)
          await this.requestCompanyTypeAPI({ todos: 'S' })
        if (this.countryList.length <= 0)
          await this.requestCountriesAPI({ todos: 'S' })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },

  mounted() {
    this.setData()
  },
}
</script>

<style></style>
